import GroupedBySection from "./GroupedBySection";
import GroupedBySelection from "./GroupedBySelection";
import Default from "./Default";

export default {
  GroupedBySelection,
  GroupedBySection,
  Default
};
